export default {"src":"/_next/static/media/Calculator.c2dd8b55.svg","height":130,"width":360,"blurWidth":0,"blurHeight":0};